const tutorialsData = [
	{
		title: 'Ships in 48 hours',
		description:
			'Seller option to receive hamper or take a credit.',
		link: 'https://www.69work.com/marketplace/register',
		backgroundImage: require('./background-tutorials.jpg'),
		avatar: require('./tutor.jpg'),
	},
	{
		title: 'All fees covered',
		description:
			'Buyers pay all card, export, and customs fees.',
		link: 'https://www.69work.com/marketplace/register',
		backgroundImage: require('./background-tutorials.jpg'),
		avatar: require('./payout.jpg'),
	},
	{
		title: 'Amazon Pay',
		description:
			'Amazon shoppers use stored credit cards.',
		link: 'https://www.69work.com/marketplace/register',
		backgroundImage: require('./background-tutorials.jpg'),
		avatar: require('./amazon-pay.jpg'),
	},
	{
		title: 'PayPal Enabled',
		description:
			'Gift with PayPal checkout or Pay in 4.',
		link: 'https://www.69work.com/marketplace/register',
		backgroundImage: require('./background-tutorials.jpg'),
		avatar: require('./paypal.jpg'),
	},
	{
		title: 'Chargeback Protection',
		description:
			'PayPal or Amazon Pay verify all gifts.',
		link: 'https://www.69work.com/marketplace/register',
		backgroundImage: require('./background-tutorials.jpg'),
		avatar: require('./law.jpg'),
	},
	{
		title: 'User Privacy',
		description:
			'Shipping address is secret and encrypted.',
		link: 'https://www.69work.com/marketplace/register',
		backgroundImage: require('./background-tutorials.jpg'),
		avatar: require('./seo.jpg'),
	},
	{
		title: 'Two Way Anonymity',
		description:
			'Gift anonymously with guest checkout.',
		link: 'https://www.69work.com/marketplace/register',
		backgroundImage: require('./background-tutorials.jpg'),
		avatar: require('./anonymity.jpg'),
	},
	{
		title: 'Supports 200+ countries',
		description:
			'Ship exportable Harrod Hampers anywhere.',
		link: 'https://www.69work.com/marketplace/register',
		backgroundImage: require('./background-tutorials.jpg'),
		avatar: require('./codetile.jpg'),
	},
	{
		title: 'VISA® balance',
		description:
			'Withdraw credits to VISA® debit or virtual cards.',
		link: 'https://www.69work.com/marketplace/register',
		backgroundImage: require('./background-tutorials.jpg'),
		avatar: require('./visa.jpg'),
	},
];

export default tutorialsData;
